export const AUTH_SIGN_IN = "/auth/signin";

export function getRoleHomePath(role?: string | null): string {
  return role === "ADMIN" ? "/all-devices" : "/devices";
}
